import React, { Fragment } from "react";

import { ReusableContentBlock as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponents } from "../PageSkeleton/Toolbox";

interface Props {
    value: Value;
}

export const ReusableContentBlock = ({ value }: Props) => {
    if (!value) return null;
    return (
        <StreamField
            tagName={Fragment}
            components={toolboxComponents}
            value={value.content}
        />
    );
};
